export const variableTypeValues = [
  { id: 1, key: 'INDIVIDUAL', label: 'individuelle' },
  { id: 2, key: 'COLLECTIVE', label: 'collective' },
];
